import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { environment } from 'src/environments/environment';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
import { FinanceService } from '../../../services';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FundWalletModal } from 'src/modules/features/contractor/modals';

interface IHeaders {
  field?: string;
  label?: string;
  type?: string;
  choices?: any[];
  op?: string;
  data?: any;
}
@Component({
  selector: 'app-withdrawal-request',
  templateUrl: './withdrawal-request.component.html',
  styleUrls: ['./withdrawal-request.component.scss'],
})
export class WithdrawalRequestComponent {
  filter: AppFilter = new AppFilter();
  baseUrl = environment.API_SERVER;
  pending: boolean;
  success: any;
  error: any;
  showToast: boolean = false;

  links = [
    {
      name: 'Transactions',
      route: '/contractor/wallet/transactions',
    },
    {
      name: 'Withdrawal Requests',
      route: '/contractor/wallet/withdrawal-request',
    },
    // {
    //   name: 'Bank Details Change Requests',
    //   route: '/contractor/wallet/change-bank-details',
    // },
  ];
  actionPerformed = [
    {
      optionId: 'APPROVED',
      optionName: 'APPROVED',
    },
    {
      optionId: 'grp Approval Ongoing',
      optionName: 'PENDING',
    },
    {
      optionId: 'CANCELLED',
      optionName: 'CANCELLED',
    },
    {
      optionId: 'REJECTED',
      optionName: 'REJECTED',
    },
    {
      optionId: 'grp Approval Ongoing',
      optionName: 'GROUP APPROVAL ONGOING',
    },
  ];

  public headers: IHeaders[] = [
    // {
    //   field: 'withdrawalRequestId',
    //   label: 'Withdrawal Request ID',
    //   type: 'text',
    //   op: 'cn',
    //   data: '',
    // },
    {
      field: 'transactionId',
      label: 'Transaction ID',
      type: 'text',
      op: 'cn',
      data: '',
    },
    // {
    //   field: 'amount',
    //   label: 'Amount',
    //   type: 'number',
    //   op: 'cn',
    //   data: Number('0'),
    // },
    // {
    //   field: 'totalCharges',
    //   label: 'Charges',
    //   type: 'number',
    //   op: 'cn',
    //   data: '',
    // },
    {
      field: 'status',
      label: 'Status',
      type: 'select',
      op: 'eq',
      choices: this.actionPerformed,
      data: '',
    },
    {
      field: 'dateCreated',
      label: 'Transaction Date',
      type: 'date',
      op: 'cn',
      data: '',
    },
  ];

  searchFilter = {
    groupOp: 'or',
    rules: [
      // {
      //   field: 'withdrawalRequestId',
      //   op: 'cn',
      //   data: '',
      //   type: 'text',
      // },
      {
        field: 'transactionId',
        op: 'cn',
        data: '',
        type: 'text',
      },

      // {
      //   field: 'amount',
      //   op: 'cn',
      //   data: Number('0'),
      //   type: 'number',
      // },

      // {
      //   field: 'totalCharges',
      //   op: 'cn',
      //   data: '',
      //   type: 'text',
      // },

      {
        field: 'status',
        op: 'cn',
        type: 'select',
        data: '',
      },
      {
        field: 'dateCreated',
        op: 'ge',
        type: 'date',
        data: '',
      },
    ],
  };
  requests = [];

  totalItems: number = this.requests.length;
  rows: number = 10;
  currentPage: number = 1;
  maxSize: number = 5;
  appUserId;
  selectedCurrencyId;
  activeCurrency;
  currencyCode;
  companyName;

  nccId = JSON.parse(localStorage.getItem('user')).organizationId.jpaContractor
    .nccId;

  unsubscribe$: Subject<void> = new Subject();
  account;

  constructor(
    private router: Router,
    private location: Location,
    private modalService: SuiModalService,
    private financeService: FinanceService,
    private walletSvc: EwalletService,
    private route: ActivatedRoute
  ) {
    this.appUserId = JSON.parse(localStorage.user).appUserId;
    console.log(this.appUserId, 'userId');
    this.companyName = JSON.parse(
      localStorage.getItem('user')
    ).organizationId.jpaContractor.companyName;

    this.filter = new AppFilter({
      _search: true,
      sidx: 'dateCreated',
      // sidx: "actionDate",
      rows: 10,
      sord: 'desc',
    });
  }

  ngOnInit(): void {
    this.selectedCurrencyId = this.route.snapshot.paramMap.get('id');
    localStorage.setItem('selectedCurrencyId', this.selectedCurrencyId);

    this.filter = new AppFilter();
    this.getCurrencies();
    this.getWithdrawalRequests(this.filter);
    this.getBalancesByCurrency();
  }

  getBalancesByCurrency() {
    this.pending = true;

    let filter = new AppFilter({
      sidx: 'walletCreatedDate',
      sord: 'desc',
      rows: 4000,
    });

    this.walletSvc
      .getBalancesByCurrency({
        currencyId: this.selectedCurrencyId,
        params: filter,
      })
      .subscribe({
        next: (res: any) => {
          res?.rows.forEach((item) => {
            if (
              item.companyName === this.companyName &&
              item.currencyId === this.selectedCurrencyId
            ) {
              this.account = item;
            }
          });

          this.pending = false;
        },
        error: (error: any) => {
          console.log(error);
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        },
      });
  }

  goBack() {
    this.location.back();
  }

  searchRecords(search) {
    if (search) {
      // Regular expression to match the specified patterns
      const regex = /^(p|pe|pen|pend|pendi|pendin|pending)$/;

      if (regex.test(search)) {
        search = 'grp Approval Ongoing';
      }

      let searchFilter = this.searchFilter;
      searchFilter.rules.forEach((rule) => {
        if (rule.type == 'number') {
          // rule.data = Number(search);
        } else if (rule.type == 'date') {
          if (!this.isInvalidDate(search)) {
            rule.data = new Date(search).toISOString().slice(0, 19).toString();
          } else {
            rule.data = new Date().toISOString().slice(0, 19).toString();
          }
        } else {
          rule.data = search;
        }
      });
      this.filter._search = true;
      this.filter.filters = JSON.stringify(searchFilter);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.currentPage = 1;
    this.filter.page = this.currentPage;
    this.filter.sidx = 'dateCreated';
    this.getWithdrawalRequests(this.filter);
  }

  isInvalidDate(inputDate) {
    const dateObject = new Date(inputDate);
    return (
      isNaN(dateObject.getTime()) || dateObject.toString() === 'Invalid Date'
    );
  }

  getCurrencies() {
    this.financeService.getCurrenciesConfig({ params: this.filter }).subscribe({
      next: (res: any) => {
        res?.rows.forEach((row: any) => {
          if (this.selectedCurrencyId == row.currencyId) {
            this.activeCurrency = row;
            this.currencyCode = row?.currencyCode;
          }
        });
        console.log(res, 'config for currency');
      },
      error: (error: any) => {
        console.log(error);
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      },
    });
  }

  getWithdrawalRequests(params: any) {
    this.pending = true;
    this.walletSvc
      .getWithdrawalRequests({
        nccId: this.nccId,
        currencyId: this.selectedCurrencyId,
        appUserId: this.appUserId,
        params: params,
      })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res: any) => {
          this.requests = res?.rows;
          this.totalItems = res?.records;
          console.log(res);
          this.pending = false;
        },
        error: (error: any) => {
          console.log(error);
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        },
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  displayRecords(noOfRows) {
    this.rows = noOfRows;
    this.filter.rows = noOfRows;
    this.getWithdrawalRequests(this.filter);
  }

  sortRecords(order: string) {
    this.filter.sord = order == 'desc' ? 'desc' : 'asc';
    this.getWithdrawalRequests(this.filter);
  }

  advancedSearch(search) {
    if (search) {
      this.filter = search;
      this.filter._search = true;
      this.filter.filters = JSON.stringify(search);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }

    this.currentPage = 1;
    this.filter.page = this.currentPage;
    this.filter.sidx = 'dateCreated';
    this.getWithdrawalRequests(this.filter);
    console.log(this.filter);
  }

  cancelAd() {
    this.filter = new AppFilter({
      page: this.currentPage,
      rows: this.rows,
    });
    this.getWithdrawalRequests(this.filter);
  }

  nextPage(page: number) {
    this.currentPage = page;
    this.filter.page = page;
    this.getWithdrawalRequests(this.filter);
  }

  cancelRequest(request) {
    this.modalService
      .open(
        new ConfirmModal(
          'Cancel Request',
          'Are you sure you want to cancel this withdrawal request?',
          ModalSize.Tiny,
          'Yes, cancel',
          'Cancel'
        )
      )
      .onApprove(() => {
        this.walletSvc
          .cancelWithdrawalRequest({
            body: { withdrawalRequestId: request?.withdrawalRequestId },
          })
          .subscribe({
            next: () => {
              this.pending = false;
              this.success = 'Withdrawal Request Cancelled';
              this.getWithdrawalRequests(this.filter);
              window.location.reload();
            },
            error: (error: any) => {
              this.pending = false;
              this.error = this.error?.error?.message
                ? this.error?.error?.message
                : error;
            },
          });
      })
      .onDeny(() => {});
  }

  fundWallet() {
    this.modalService.open(new FundWalletModal(this.account));
  }
}
